const ProfileServicesForm = {
  computed: {
    ...Vuex.mapState(['profile']),
  },
  components: {
    'term-search': TermSearch,
    'dmtk-textarea': FormTextArea,
    'uploader-service': UploaderService,
  },
  mixins: [vuelidate.validationMixin],
  data() {
    return {
      file: null,
      service: {
        title: '',
        description: '',
        activity: '',
        files: [],
      },
    };
  },
  props: {
    id: { default: false },
  },
  created() {
    if (!this.id) return;
    this.loading = true;
    this.$dmtk.services.read(this.id).then((data) => {
      this.service = data.service;
      this.loading = false;
    });
  },
  methods: {
    open() {
      if (!this.service.slug) return;
      window.open(`/anuncios/${this.service.slug}/`);
    },
    save() {
      this.$v.$touch();
      /*

			if (this.$v.$invalid) {
			  UIkit.modal.alert('¡Revisa tus datos!');
			  return;
			}
	  
			 */
      this.$dmtk.services.save(this.service).then((result) => {
        this.service._id = result._id;
        this.service.slug = result.slug;
        this.service.status = result.status;
        return customAlert(
          'Tu servicio se guardado con éxito',
          result.status === 'active'
            ? 'Actualizaremos tu servicio en unos minutos.'
            : 'Por favor sigue modificando tu servicio para que podamos activarlo.',
        ).then(() => {
          if (this.id) return;
          this.$router.push({
            name: 'service.form',
            params: { id: result._id },
          });
        });
      });
    },
    appendFile(file) {
      this.editFile(file);
      this.service.files.push(file);
      if (!this.id) {
        this.service._id = file.service._id;
        this.save();
      }
    },
    editFile(file) {
      this.file = file;
      UIkit.modal('#file-edit', { stack: true })
        .show()
        .then(() => {
          document
            .getElementById('file-edit')
            .querySelector('input[type=text]')
            .focus();
        });
    },
    updateFile(file) {
      return this.$dmtk.services
        .updateFile({
          file: file._id,
          title: file.title,
        })
        .then((result) => {
          UIkit.modal('#file-edit').hide();
        });
    },
    removeFile(file) {
      UIkit.modal
        .confirm('¿Seguro que deseas borrar este archivo?', { stack: true })
        .then(() => {
          this.$dmtk.services
            .removeFile({
              file: file._id,
              service: this.service._id,
            })
            .then((result) => {
              UIkit.modal('#file-edit').hide();
              const idx = this.service.files.indexOf(file);
              if (idx < 0) return;
              this.service.files.splice(idx, 1);
            });
        });
    },
  },
  validations() {
    return {
      service: {
        title: {
          required: validators.required,
          //minLength: validators.minLength(4),
          maxLength: validators.maxLength(80),
        },
        description: { required: validators.required },
        //activity: { required: validators.required },
      },
    };
  },
  template: `
    <div class="uk-margin-large-bottom">
    <h3 class="uk-text-bold uk-text-uppercase dmtk-blue">
      <span v-if="id">Editar servicio</span>
      <span v-else>Añadir nuevo servicio</span>
    </h3>

    <div class="uk-grid uk-child-width-1-2@m">
      <div>
        <div class="uk-margin-top">
          <label>Título del servicio</label>
          <input
            v-model="service.title"
            type="text" class="uk-input"
            @change="$v.service.title.$touch()"
          />
          <div class="uk-text-danger" v-if="$v.service.title.$dirty && !$v.service.title.required">
            Por favor introduce el título del anuncio
          </div>
          <div class="uk-text-danger" v-if="!$v.service.title.maxLength">
            El título no puede tener más de 80 caracteres.
          </div>
          <div class="uk-margin-small-top">El titulo debe ser lo más descriptivo posible</div>
        </div>
        <div class="uk-margin-top">
          <label>Actividad</label>
          <term-search
            v-model="service.activity"
            placeholder="Actividad a realizar"
            taxonomy="activities" scope="activity"
          ></term-search>
          <div class="uk-margin-small-top">Pon tus anuncios de acuerdo a las actividades en las que ofreces tus servicios</div>
        </div>
      </div>
      <div>
        <div class="uk-margin-top">
          <label>Descripción del servicio</label>
          <dmtk-textarea
            rows="10"
            :value="service.description"
            @input="service.description = $event"
            @blur="$v.service.description.$touch()"
            placeholder="Escribe aquí la descripción de tu servicio"
          ></dmtk-textarea>
          <div class="uk-text-danger" v-if="$v.service.description.$anyError">
            Por favor introduce la descripción del anuncio
          </div>
          <div class="uk-margin-small-top">
            Por favor no publiques anuncios repetidos ni incluyas datos personales.
            Todos los anuncios serán revisados por un editor y podrán ser borrados.
          </div>
        </div>
      </div>
    </div>

    <h4 class="dmtk-blue">Imágenes del servicio</h4>
    <div class="gallery -services" v-if="service.files.length">
      <div class="image" v-for="file in service.files">
        <img :src="file.url" :alt="service._id" />
        <button @click="editFile(file)" class="uk-badge -edit">Editar</button>
      </div>
    </div>
    <div class="upload uk-margin-top" v-if="service.files.length < 6">
      <uploader-service
        :service="id"
        @append="appendFile"
        @remove="removeFile"
      ></uploader-service>
    </div>
    <div class="uk-margin-small-top">Dale más visibilidad a tu anuncio, añade imágenes o fotografías.</div>

    <div id="file-edit" uk-modal>
      <div class="uk-modal-dialog uk-margin-auto-vertical">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-modal-header">
          <h3 class="uk-modal-title">Editar imagen</h3>
        </div>
        <div class="uk-modal-body">
          <div v-if="file">
            <div class="uk-text-center">
              <img :src="file.url" alt="Imagen a editar" class="uk-width-medium">
            </div>
            <div class="uk-margin-top uk-margin-bottom">
              <label>Título de la imagen</label>
              <input
                v-model="file.title"
                type="text" class="uk-input"
              />
            </div>
          </div>
        </div>
        <div class="uk-modal-footer uk-background-default">
          <div class="uk-flex uk-flex-between">
            <div>
              <button
                @click="removeFile(file)"
                class="uk-button uk-button-danger" type="button"
              >Borrar</button>
            </div>
            <div class="uk-text-right">
              <button class="uk-button uk-button-default uk-modal-close" type="button">Cerrar</button>
              <button
                @click="updateFile(file)"
                class="uk-button uk-button-primary" type="button"
              >Guardar</button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <hr>
    <div class="uk-flex uk-flex-between uk-margin-top">
      <div>
        <button
          @click="open()"
          class="uk-button uk-margin-right"
          v-if="id && service.status === 'active'"
        >Ver servicio
        </button>
      </div>
      <div class="uk-text-right">
        <button
          @click="save()"
          class="uk-button uk-button-dmtk"
        >
          <span v-if="id || $v.$invalid">Guardar servicio</span>
          <span v-else>Publicar servicio</span>
        </button>
      </div>
    </div>
    </div>
  `,
};
